<template>
  <modal width="40" :show-modal="showModal" @close-modal="$emit('close-modal')">
    <div class="delete-modal">
      <div class="flex justify-center">
        <img src="/icons/circle-check-outside.svg" />
      </div>

      <div class="my-6">
        <div>
          <div><b class=" font-semibold text-xl">Consolidation Successful</b></div>
          <span class="text-sm text-gray-400">The shipments have been successfully consolidated.</span>
          <div class=" flex justify-center mt-5">
               <base-button text="Close" @click="$router.push('/operations/consolidation')"/>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
    }
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  }
};
</script>

<style scoped>
.delete-modal {
  text-align: center;
}
</style>